import React, { useState } from "react";
import { Checkbox } from "tea-component";
import "./index.scss";
import classNames from "classnames";
import { useIntl } from "umi";
import { LANGUAGE_EN } from "@home/_config/config";
import { getLanguage } from "@home/utils/common";

type TItem = { value: string; name: string; nameEn: string; nameCn: string; };

interface IProps {
  className?: string;
  checkClassName?: string;
  style?: React.CSSProperties;
  checkList: TItem[];
  value: string[];
  children?: React.ReactNode;
  onChange?: (value: any) => void;
}

/**
 * 通用复选框组件
 * @param props - 组件属性
 * @param props.checkList - 复选框选项列表
 * @param props.onChange - 选中状态变更的回调函数
 * @param props.value - 当前选中的值
 * @param props.className - 自定义类名
 * @param props.style - 自定义样式
 * @returns 渲染复选框组
 */
const CommonCheckBox = (props: IProps) => {
  const { checkList, onChange, value, className, checkClassName, style, children, ...resetProps } = props;
  const { locale } = useIntl();
  const isEN = locale === LANGUAGE_EN;
  const [activeList, setActiveList] = useState<string[]>(value || []);

  /**
   * 处理复选框选中状态变更的回调函数
   * @param value - 当前选中的选项值列表
   * @description 更新内部选中状态并触发外部onChange回调
   */
  const handleChange = (value: string[]) => {
    setActiveList(value);
    onChange?.(value);
  };

  return <div className={classNames(className)} style={style ? style : {}}>
    <div className={classNames('dbd-common-check-box', checkClassName)}>
      <Checkbox.Group value={activeList} onChange={handleChange}>
        {
          checkList?.map((item: TItem) => <Checkbox key={item?.value} name={item?.value}>{getLanguage(isEN, item?.nameEn, item?.nameCn) || item?.name}</Checkbox>)
        }
      </Checkbox.Group>
    </div>
    {React.Children.map(children, (child: any) => React.cloneElement(
      child,
      {
        ...resetProps,
        activeList,
        checkList,
      }
    ))}
  </div>;
};

export default CommonCheckBox;